module.exports = __webpack_public_path__ + "media/images/team_meet-47a09c9f.jpg";